export default __webpack_public_path__ + "static/media/i2200.745685a6.jpg";